import api from '@pray/shared/utils/api';

export async function deleteContentSeries({ artistId, contentSeriesId, locale = null }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentSeriesId) throw Error('Content Series ID is required');

  const url = `/web/studio/artists/${artistId}/content-series/${contentSeriesId}`;

  const body = locale ? { locale_code: locale } : undefined;
  const response = await api.executeDeleteRequest(url, body);

  return response.data.data;
}
